<template>
  <section class="contact-us">
    <AppHeader></AppHeader>
    <div id="top-content" class="container-fluid inner-page">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="page-title">Contact us</div>
            <div class="page-subtitle">
              Got a question? We’d love to hear from you. Send us a message and we’ll respond as
              soon as possible.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="details" class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <div class="col-title">Contact form</div>
            <iframe
              title="Feedback Form"
              class="freshwidget-embedded-form"
              id="freshwidget-embedded-form"
              src="https://verloophq.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=Contact+form&submitTitle=Send+now&submitThanks=Thank+you+for+your+message.+We'll+be+in+touch+with+you+soon.&screenshot=No&searchArea=no&captcha=yes"
              scrolling="no"
              height="500px"
              width="100%"
              frameborder="0"
            ></iframe>
          </div>
          <div class="col-md-5 contacts">
            <div class="col-title">Office Locations</div>

            <h4>United States</h4>
            <p>
              Verloop,
              <br />3901 Locust Walk MB 613,
              <br />Philadelphia, PA 19104-6135
              <br />
              <strong>Contact number:</strong> +1 408 600 2613
              <br />
              <strong>Email:</strong> sales@verloop.io
            </p>

            <h4>India</h4>
            <p>
              Verloop,
              <br /># 3582,13 G Main Road,
              <br />4th Cross Rd, Indiranagar,
              <br />Bengaluru, Karnataka 560008
              <br />

              <strong>Contact number:</strong> +91 814 743 8858
              <br />
              <strong>Email:</strong> hello@verloop.io
            </p>
          </div>
        </div>
      </div>
    </div>
    <MoreInfo></MoreInfo>
    <AppFooter></AppFooter>
  </section>
</template>

<script>
import AppHeader from "@/components/Header/Header.vue";
import AppFooter from "@/components/Footer/Footer.vue";
import MoreInfo from "@/components/MoreInfo.vue";

export default {
  name: "contact-us",
  components: {
    AppHeader,
    AppFooter,
    MoreInfo
  }
};
</script>

<style scoped lang="scss"></style>

